import client from './client'
import type { RacePriceTier, RacePricing, StoreRacePriceTierPayload } from '@/types/events'

export interface RacePriceTierList {
  tiers: RacePriceTier[]
  pricing: RacePricing
}

const base = (eventSlug: string, editionSlug: string, raceSlug: string): string =>
  `/organizer/events/${eventSlug}/editions/${editionSlug}/races/${raceSlug}/price-tiers`

export async function listRacePriceTiers(
  eventSlug: string,
  editionSlug: string,
  raceSlug: string,
): Promise<RacePriceTierList> {
  const { data } = await client.get<{ data: RacePriceTier[]; meta: { pricing: RacePricing } }>(
    base(eventSlug, editionSlug, raceSlug),
  )
  return { tiers: data.data, pricing: data.meta.pricing }
}

export async function createRacePriceTier(
  eventSlug: string,
  editionSlug: string,
  raceSlug: string,
  payload: StoreRacePriceTierPayload,
): Promise<RacePriceTier> {
  const { data } = await client.post<{ data: RacePriceTier }>(
    base(eventSlug, editionSlug, raceSlug),
    payload,
  )
  return data.data
}

export async function updateRacePriceTier(
  eventSlug: string,
  editionSlug: string,
  raceSlug: string,
  tierId: number,
  payload: StoreRacePriceTierPayload,
): Promise<RacePriceTier> {
  const { data } = await client.put<{ data: RacePriceTier }>(
    `${base(eventSlug, editionSlug, raceSlug)}/${tierId}`,
    payload,
  )
  return data.data
}

export async function reorderRacePriceTiers(
  eventSlug: string,
  editionSlug: string,
  raceSlug: string,
  tierIds: number[],
): Promise<RacePriceTier[]> {
  const { data } = await client.put<{ data: RacePriceTier[] }>(
    `${base(eventSlug, editionSlug, raceSlug)}/reorder`,
    { tier_ids: tierIds },
  )
  return data.data
}

export async function deleteRacePriceTier(
  eventSlug: string,
  editionSlug: string,
  raceSlug: string,
  tierId: number,
): Promise<void> {
  await client.delete(`${base(eventSlug, editionSlug, raceSlug)}/${tierId}`)
}
